import React from 'react';

import UserSkeleton from '~/boilerplates/User';
import Dashboard from '~/containers/User/CSAT/Dashboard';
import { DashboardContextProvider } from '~/contexts/CSAT/DashboardContext';

export default function index() {
  return (
    <UserSkeleton>
      <DashboardContextProvider>
        <Dashboard />
      </DashboardContextProvider>
    </UserSkeleton>
  );
}
